// 负责所有全局组件的注册
import BetweenRow from './betweenRow'
import vueCropper from './vue-cropper'
import screeningItem from './common/screeningItem'
export default {
  install(Vue) {
    Vue.component('BetweenRow', BetweenRow)
    Vue.component('screeningItem', screeningItem)
    Vue.component('vue-cropper', vueCropper)
  }
}



// WEBPACK FOOTER //
// ./src/components/index.js